import ls from 'local-storage'

export default{
  data () {
    return {
      rules: {
        'name': [
          { required: true, message: 'Tên không thể để trống', trigger: 'change' },
          { min: 5, max: 255, message: 'Tên phải chứa từ 5 đến 255 ký tự', trigger: 'change' }
        ],
        'short_name': [
          { required: true, message: 'Tên rút gọn không thể để trống', trigger: 'change' }
        ]
      },
      logo: {},
      localBank: {
        name: '',
        short_name: '',
        logo: '',
        url: ''
      },
      uploadLogoUrl: process.env.API_URI + '/banks/images',
      uploadHeader: {},
      submitting: false
    }
  },
  methods: {
    handleLogoUpload (res, file) {
      if (res.code) {
        this.logo = res.data
        this.localBank.logo = res.data.name
      }
    },
    beforeLogoUpload (file) {

    },
    newBank () {
      this.localBank = {
        name: '',
        short_name: '',
        logo: '',
        url: ''
      }
    }
  },
  mounted () {
    this.newBank()
    this.uploadHeader.Authorization = `Bearer ${ls.get('authen').access_token}`
  },
  watch: {
    localBank: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/bank/mixins/index.js